import { render, staticRenderFns } from "./AppVersionsPage.vue?vue&type=template&id=a50c6fc6&scoped=true&"
import script from "./AppVersionsPage.vue?vue&type=script&lang=js&"
export * from "./AppVersionsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50c6fc6",
  null
  
)

export default component.exports